import { Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { IInputDialogData } from './input-dialog-data';

@Component({
  selector: 'kh-input-dialog',
  styleUrls: ['./input-dialog.component.less'],
  templateUrl: './input-dialog.component.html',
  standalone: false
})
export class InputDialogComponent implements IInputDialogData {
  readonly bsModalRef = inject(BsModalRef);
  private readonly builder = inject(FormBuilder);

  public title = '';
  public body = '';
  public firstButtonText = '';
  public secondButtonText = '';
  public inputControl: AbstractControl;

  public firstButtonHandler(value: string): void {
    // do nothing. That is a placeholder.
  }

  public secondButtonHandler(): void {
    // do nothing. That is a placeholder.
  }

  public constructor() {
    const builder = this.builder;

    this.inputControl = builder.control('', Validators.required);
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public onFirstButtonClick(): void {
    this.inputControl.markAsTouched();
    if (this.inputControl.valid) {
      this.close();
      this.firstButtonHandler(this.inputControl.value);
    }
  }

  public onSecondButtonClick(): void {
    this.close();
    this.secondButtonHandler();
  }
}
